import React from 'react';

import { Shop } from '@entities/shop';

const ShopPage = () => {
	return <Shop />;
};

export default ShopPage;
